import { render } from '@testing-library/react';
import { Col, Row } from 'react-materialize';
import '../styles/main.css';
import Product from './product';

export default function Shop() {


    const renderContent = () => {
        return(
            Array(15).fill('.').map(i => <div className='child'><Product /></div>)
        )
    }

    return (
        <div className='shop-container'>
            {renderContent()}
        </div>
    )
}